import axios from 'axios';

import { publicAxiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';
import { customerId } from 'common/helpers/tokenHelper';

export const getClubPackageByClubId = (clubId) =>
  axios.get(
    `${getV2RootUrl()}/club-package/next/for-web?clubId=${clubId}`,
    publicAxiosHeaderV2()
  );

export const getClubPackage = (clubPackageId) => {
  return axios.get(
    `${getV2RootUrl()}/club-package/${clubPackageId}/for-web`,
    publicAxiosHeaderV2()
  );
};

export const updateClubPackageItems = (shipmentId, data) => {
  const custId = customerId();
  return axios.put(
    `${getV2RootUrl()}/customer/${custId}/club-package/shipment/${shipmentId}/for-web`,
    { items: data },
    publicAxiosHeaderV2()
  );
};

export const getClubPackageItems = (shipmentId) => {
  const custId = customerId();
  return axios.get(
    `${getV2RootUrl()}/customer/${custId}/club-package/shipment/${shipmentId}/for-web`,
    publicAxiosHeaderV2()
  );
};
